import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, withModifiers as _withModifiers, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-area-id"]
const _hoisted_2 = ["title"]

import { computed, inject, reactive } from 'vue'
import type { Programa } from '@/interfaces/Programa'


export default /*@__PURE__*/_defineComponent({
  __name: 'AreaCard',
  props: {
    area: {},
    nivel: {},
    seleccionada: { type: Boolean },
    enRuta: { type: Boolean },
    opaca: { type: Boolean }
  },
  emits: ["seleccionar", "reordenar"],
  setup(__props: any, { emit: __emit }) {

/**
 * Tarjeta de un área del árbol organizacional.
 *
 * Componente de presentación. Recibe sus datos por props o del store del módulo.
 */

const props = __props

const emit = __emit

const dragState = inject<{
  dragging: Programa | null
  dropTargetId: number | null
  dropSide: 'before' | 'after'
}>('areaDragState', reactive({ dragging: null, dropTargetId: null, dropSide: 'after' as const }))

const isDragging    = computed(() => dragState.dragging?.id_programa === props.area.id_programa)
const isDropTarget  = computed(() => dragState.dropTargetId === props.area.id_programa)
const isValidDrop   = computed(() =>
  dragState.dragging != null &&
  dragState.dragging.id_programa !== props.area.id_programa &&
  dragState.dragging.padre_id === props.area.padre_id
)

function onDragStart(e: DragEvent) {
  dragState.dragging = props.area
  if (e.dataTransfer) e.dataTransfer.effectAllowed = 'move'
}

function onDragOver(e: DragEvent) {
  if (!isValidDrop.value) return
  dragState.dropTargetId = props.area.id_programa!
  const rect = (e.currentTarget as HTMLElement).getBoundingClientRect()
  dragState.dropSide = e.clientX < rect.left + rect.width / 2 ? 'before' : 'after'
}

function onDragEnd() {
  dragState.dragging = null
  dragState.dropTargetId = null
}

function onDrop() {
  if (!dragState.dragging || !isValidDrop.value) {
    dragState.dragging = null
    dragState.dropTargetId = null
    return
  }
  const dragged = dragState.dragging
  const side    = dragState.dropSide
  dragState.dragging = null
  dragState.dropTargetId = null
  emit('reordenar', { dragged, target: props.area, side })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["area-chip", {
      dragging: isDragging.value,
      'drop-before': isDropTarget.value && _unref(dragState).dropSide === 'before',
      'drop-after':  isDropTarget.value && _unref(dragState).dropSide === 'after',
      seleccionada: _ctx.seleccionada,
      'en-ruta': _ctx.enRuta,
      opaca: _ctx.opaca
    }]),
    "data-area-id": _ctx.area.id_programa,
    draggable: true,
    onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$emit('seleccionar', _ctx.area)), ["stop"])),
    onDragstart: _withModifiers(onDragStart, ["stop"]),
    onDragover: _withModifiers(onDragOver, ["stop","prevent"]),
    onDragend: onDragEnd,
    onDrop: _withModifiers(onDrop, ["stop","prevent"])
  }, [
    _createElementVNode("span", {
      class: "drag-handle",
      onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
      title: "Arrastrar"
    }, "⠿"),
    _createElementVNode("span", {
      class: "chip-nombre",
      title: _ctx.area.nombre
    }, _toDisplayString(_ctx.area.nombre), 9, _hoisted_2)
  ], 42, _hoisted_1))
}
}

})